import React from "react";
import { IconType } from "react-icons";

import {
  detailSectionClass,
  detailSectionTitleClass,
} from "../ui/styles";

type Props = {
  title: string;
  icon?: IconType;
  children: React.ReactNode;
};

// A part of a detail card below a dividing line: its heading, then its content.
const DetailSection = ({ title, icon: Icon, children }: Props) => (
  <section className={detailSectionClass}>
    <h3 className={detailSectionTitleClass}>
      {Icon && <Icon className="h-5 w-5 shrink-0" />}
      {title}
    </h3>

    <div className="mt-4">{children}</div>
  </section>
);

export default DetailSection;
